import { appConfig } from '@/config/app-config';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import BPCApiServiceInstance from '@core/services/bpc-api-service.instance';
import { DownloadPdfUsingTemplateModel } from '@tools/interfaces/template';
import printJS from 'print-js';
import BPCMessageService from '@core/services/bpc-messages.service';
import { isArray } from 'lodash';

export default class PrintTemplateService {
  protected $routeHelper: BPCApiRouteHelper;
  protected $bpcApi: BPCApiServiceInstance;
  protected $bpcMessage: BPCMessageService;
  constructor() {
    this.$routeHelper = new BPCApiRouteHelper();
    this.$bpcApi = new BPCApiServiceInstance({ apiPath: appConfig.apiPathV1 });
    this.$bpcMessage = new BPCMessageService();
  }

  async printTemplate(entityName: string, entityId: number | number[], templateId: number) {
    const path = `${this.$routeHelper.getEntityPath('templates')}/pdf-to-print`;
    const body: DownloadPdfUsingTemplateModel = {
      entity_name: entityName,
      template_id: templateId,
      entity_ids: isArray(entityId) ? entityId : [entityId],
    };
    try {
      const response = await this.$bpcApi.post(path, body).toPromise();
      printJS({ printable: response.data, type: 'pdf', base64: true });
    } catch (e) {
      this.$bpcMessage.showErrorMessage({
        text: 'global.error_printing_message',
      });
    }
  }
}
